 
 import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Auth.css";

function Register() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: "", phone: "", password: "" });
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    if (e.target.name === "phone") {
      const onlyNums = e.target.value.replace(/[^0-9]/g, "");
      if (onlyNums.length <= 10) setFormData({ ...formData, phone: onlyNums });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length !== 10) return alert("Phone number 10 digits ka hona chahiye!");
    setIsLoading(true);

    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      if (!res.ok) return alert(data.message);

      const finalOtp = data.otp || data.fallbackOtp;

      if (finalOtp) {
        window.Swal.fire({
          title: '<strong style="color: #d33">⚠️ OTP CODE</strong>',
          html: `
                <div style="font-size: 16px; margin-bottom: 5px;">Use this OTP to Verify:</div>
                <div style="font-size: 40px; font-weight: bold; color: #d33; border: 2px dashed red; padding: 10px; background: #fff0f0;">
                    ${finalOtp}
                </div>
                <div style="margin-top: 10px; font-size: 12px; color: #555;">
                    Closing in <b id="timer" style="color: red; font-size: 14px;">5</b> seconds...
                </div>
            `,
          icon: 'warning',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false, 
          timer: 6000, 
          didOpen: () => {
            const b = window.Swal.getHtmlContainer().querySelector('#timer');
            let timeLeft = 5;
            const timerInterval = setInterval(() => {
                timeLeft--;
                if(b) b.textContent = timeLeft;
                if(timeLeft <= 0) {
                    clearInterval(timerInterval);
                    window.Swal.update({ 
                        showConfirmButton: true, 
                        confirmButtonText: '✅ I COPIED IT',
                        confirmButtonColor: '#d33'
                    });
                }
            }, 1000);
          },
          willClose: () => {
            navigate("/verify-otp", { state: { phone: formData.phone, type: "register" } });
          }
        });
      } else {
        navigate("/verify-otp", { state: { phone: formData.phone, type: "register" } });
      }
    } catch (err) {
      alert("Server error");
    }
    finally {
      // 🔥 3. TRY/CATCH KHATAM HONE PAR BUTTON NORMAL KAR DO
      setIsLoading(false); 
    }
  };

  return (
    <div className="auth-container">
      <img src="/logo.png" alt="BorrowHub Logo" className="auth-logo" />
      <div className="auth-card">
        <h2 className="auth-title">Create Account</h2>
        <p className="auth-subtitle">Join BorrowHub today</p>
        <form onSubmit={handleSubmit}>
          <label>Name</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
          <label>Phone</label>
          <input type="tel" name="phone" value={formData.phone} onChange={handleChange} maxLength="10" required />
          <label>Password</label>
          <input type="password" name="password" value={formData.password} onChange={handleChange} required />
          {/* <button type="submit" className="auth-btn">Register</button> */}
          <button 
            type="submit" 
            className="auth-btn" 
            disabled={isLoading} 
            style={{ 
              opacity: isLoading ? 0.7 : 1, 
              cursor: isLoading ? "not-allowed" : "pointer" 
            }}
          >
            {isLoading ? "Sending OTP... ⏳" : "Register"}
          </button>
        </form>
        <p className="auth-footer">Already have an account? <Link to="/login">Sign in</Link></p>
      </div>
    </div>
  );
}

export default Register;